import { VideoSwitchIcon } from './VideoSwitchIcon';

/**
 * author: Google
 * id 465D18D8-ABEA-4D2B-8A05-C6555C36803F
 * name video-switch
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/video-switch.svg
 * tags
 * - Video / Movie 
 */
export const SwitchVideoIcon = VideoSwitchIcon;
export default SwitchVideoIcon